export default __webpack_public_path__ + "static/flyerFrontThumb2-42b8a31ccdce7162f25d5cc662348368.jpg";